import { Injectable } from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router} from '@angular/router';
import {LocalizeRouterService} from '@gilsdav/ngx-translate-router';


@Injectable({
  providedIn: 'root'
})
export class MarketplaceGuard implements CanActivate {
  constructor(private router: Router,
              private localize: LocalizeRouterService,) {
  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {
    const isMarketplaceMode = Boolean(localStorage.getItem('DWallMarketplaceMode'));
    if (!isMarketplaceMode) {
      const path = this.localize.translateRoute('/app/devices');
      this.router.navigate([path]);
    }
    return isMarketplaceMode;
  }

}
